import * as React from 'react';

const VisaPaymentRebrandingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        <g id="logo-payment-visa-rebranding">
            <g id="fill">
                <path
                    d="M18.9806 10.6807L18.1943 12.849H19.4331L18.9806 10.6807Z"
                    fill="#161719"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 4C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4H3ZM10.6751 14.8946L11.9103 9.12082H10.4169L9.18158 14.8946H10.6751ZM21.2422 14.8946H19.8607L19.6809 14.0324H17.7646L17.4532 14.8946H15.8848L18.1255 9.54442C18.2332 9.28748 18.4749 9.12082 18.7615 9.12082H20.0367L21.2422 14.8946ZM14.6071 11.3843C15.2113 11.7014 15.9664 12.0976 15.9626 13.0094C15.9575 14.2097 14.931 14.9849 13.3622 14.9849C12.6939 14.9777 12.0497 14.8385 11.7009 14.6782L11.9715 13.4131C11.9817 13.4178 11.992 13.4227 12.0024 13.4275C12.3448 13.5874 12.7768 13.7892 13.5058 13.7777C13.9353 13.7709 14.3956 13.6002 14.3994 13.2126C14.402 12.9595 14.2064 12.7782 13.6246 12.4952C13.0586 12.2189 12.3076 11.7551 12.3169 10.9239C12.3257 9.80008 13.3647 9.0152 14.8409 9.0152C15.4162 9.0152 15.8787 9.14074 16.2382 9.27122L15.9761 10.4956C15.3069 10.1877 14.7176 10.2091 14.5032 10.237C14.0718 10.2935 13.8742 10.5135 13.8698 10.7209C13.864 10.9944 14.2015 11.1715 14.6071 11.3843ZM7.35616 14.8946L9.77604 9.12082H8.20683L6.6526 13.0507L6.0236 9.70944C5.95014 9.33646 5.65867 9.12082 5.33485 9.12082H2.79345L2.75781 9.28858C3.27954 9.40188 3.87254 9.58481 4.23127 9.77943C4.4511 9.89912 4.51397 10.0029 4.58633 10.2867L5.77708 14.8946H7.35616Z"
                    fill="#161719"
                />
            </g>
        </g>
    </svg>
);

VisaPaymentRebrandingSvg.displayName = 'VisaPaymentRebrandingSvg';
export default VisaPaymentRebrandingSvg;
